import React, { Component } from "react";
import ElectronicVerification from "@formatic/electronic-verification";
import AbnLookupComponent from "@formatic/abn-lookup";
import { Overrides } from "@formatic/sdk";

import OneRegistryLayout from "./layouts/OneRegistry";
import Formatic from "./components/Formatic";
import { ParamsFromURL } from "./common/methods";

import "@formatic/electronic-verification/dist/bundle.css";

const formProps = {
  apiServerUrl: "https://api.transformd.com",
  serverUrl: "https://api.transformd.com/graphql",
  subscriptionServerUrl: "wss://api.transformd.com/subscriptions"
};

const params = ParamsFromURL();
class App extends Component {
  render() {
    return (
      <OneRegistryLayout>
        <div className="page__example-fsf">
          <Formatic
            {...formProps}
            formId={781}
            apiKey="9E52047d994aF9BDE5a707701d4b451ca3Bf220F21Cf53e3fC24caBA5AA51674"
            submissionId={params.sessionId}
            environment="Live"
            channel="master"
            config="default"
            theme="transformd"
          >
            <Overrides.OverrideFieldContainer
              type="electronicVerification"
              component={ElectronicVerification}
            />
            <Overrides.OverrideFieldContainer
              component={AbnLookupComponent}
              // this dosnt work but we need this for api
              type="abnLookup"
            />
          </Formatic>
        </div>
      </OneRegistryLayout>
    );
  }
}

export default App;
